<template>
  <!--
    	作者：luoyiming
    	时间：2020-06-20
    	描述：diy组件-参数设置-搜索栏
    -->
  <div>
    <div class="common-form"><span>{{ curItem.name }}</span></div>
     <el-form size="small" :model="curItem" label-width="100px">
       <el-form-item label="提示文字：">
         <el-input v-model="curItem.params.placeholder"></el-input>
       </el-form-item>
       <el-form-item label="搜索框样式：">
         <el-radio-group v-model="curItem.style.searchStyle">
             <el-radio :label="3">方形</el-radio>
             <el-radio :label="6">圆角</el-radio>
             <el-radio :label="9">圆弧</el-radio>
           </el-radio-group>
       </el-form-item>
       <el-form-item label="文字对齐：">
         <el-radio-group v-model="curItem.style.textAlign">
             <el-radio :label="3">居左</el-radio>
             <el-radio :label="6">居中</el-radio>
             <el-radio :label="9">居右</el-radio>
           </el-radio-group>
       </el-form-item>
       <!-- 搜索栏图标 -->
       <el-form-item label="右侧图标：">
         <el-radio-group v-model="curItem.params.icon_show">
           <el-radio :label="1">显示</el-radio>
           <el-radio :label="0">隐藏</el-radio>
         </el-radio-group>
       </el-form-item>

       <!-- 上传搜索栏图标 -->
       <el-form-item label="图标设置：" prop="image_id">
         <el-row>
           <el-button type="primary" @click="openUpload">选择图片</el-button>
           <div v-if="curItem.params.img_url!=''" class="img">
             <img :src="curItem.params.img_url" width="100" height="100" />
           </div>
           <el-input type="hidden" v-model="curItem.params.img_url" ></el-input>
         </el-row>
       </el-form-item>
       <!--图标链接-->
       <el-form-item label="图标链接：">
           <el-input v-model="curItem.params.icon_link"></el-input>
           <div class="url-box" >
             <el-button type="primary" @click="changeLink(index)" style="margin-top:10px;">选择链接</el-button>
           </div>
       </el-form-item>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <SetLink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</SetLink>
  </div>
</template>

<script>
  import Upload from '@/components/file/Upload';
  import SetLink from '@/components/setlink/Setlink';
  export default {
    components: {
      Upload,
      SetLink,
    },
    data() {
      return {
        image_id:'',
         /*是否上传图片*/
        isupload: false,
        index: null,
        urlList : [],
        /*是否选择链接*/
        is_linkset: false,
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {

    },
    methods: {
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        console.log(e);
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.image_id = e[0].file_id;
          this.curItem.params.img_url = this.file_path;
        }
        this.isupload = false;
      },


      /*选择链接*/
        changeLink(index) {
            this.is_linkset = true;
            this.index = index;
        },

    /*获取链接并关闭弹窗*/
      closeLinkset(e) {
          this.is_linkset = false;
          if (e) {
            this.curItem.params.icon_link = e.url
            // this.curItem.data[this.index].name = e.name
          }
      },
    }
  };
</script>

<style scoped>
  .img {
     margin-top: 10px;
   }
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Search.vue